
import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
 import "./Header.css";
import APTechLogo2 from "./Images/A.pTechNewLogo_4.png";
import "./xyz.css";
import MobileLanguageDropdown from "./MobileLanguageDropdown";
import TranslateWidget from "./TranslateWidget";
import CustomLanguageDropdown from "./CustomLanguageDropdown";
import "./HomePageContent.css";
import { FaCode, FaMobileAlt, FaBullhorn, FaCloud, FaTools} from "react-icons/fa";
import { SiSalesforce } from 'react-icons/si';
import SearchPopup from "./SearchPopup";

function Header() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();


 //close scroll body when menu open
    useEffect(() => {
        document.body.classList.toggle('menu-open', isMobileMenuOpen);
    }, [isMobileMenuOpen]);
      
    // Close menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
        setActiveDropdown(null);
    }, [location]);
     

    const isAboutActive =
        location.pathname.startsWith("/AboutUs") ||
        location.pathname.startsWith("/Companyoveriew") ||
        location.pathname.startsWith("/PrivacyPolicy") ||
        location.pathname.startsWith("/TermsAndcondition") ||
        location.pathname.startsWith("/BlogsAndArticles") ||
        location.pathname.startsWith("/Gallery") ||
        location.pathname.startsWith("/LatestUpdate");

    const isProductActive =
        location.pathname.startsWith("/ApiProductList") ||
        location.pathname.startsWith("/IntermediatesList") ||
        location.pathname.startsWith("/ExcipientsList") ||
        location.pathname.startsWith("/InorganicChemicalsList") ||
        location.pathname.startsWith("/OrganicChemicalsList") ||
        location.pathname.startsWith("/CosmaticsandPersonalCareProducts") ||
        location.pathname.startsWith("/PharmaAndFoodGradeOils") ||
        location.pathname.startsWith("/WaterTreatmentMining") ||
        location.pathname.startsWith("/FlavourFragrance");

    const handleSearch = (value) => {
        if (value.trim()) {
            navigate(`/search?query=${encodeURIComponent(value.trim())}`);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (isMobileMenuOpen) {
            setActiveDropdown(null);
        }
    };

    const toggleDropdown = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    return (

       <>


            <header className="header" id="desktop-header">
            <div className="header-container">

                {/* --- Left: Logo --- */}
                <div className="logo-container">
                    <NavLink to="/" className="nav-link">
                    <img
                         src={APTechLogo2}
                        alt="A.P Tech Solution"
                        className="logo"
                    />
                    </NavLink>
                </div>

                {/* --- Center: Navigation Menu --- */}
                <nav className="main-nav">
                    <ul>
                        <li className="nav-item">
                            <NavLink to="/" className="nav-link" end>
                                HOME
                            </NavLink>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink to="/AboutUs" className="nav-link">
                                ABOUT US
                            </NavLink>

                            <div className="dropdown-content">
                                {/* <NavLink to="/AboutUs" className="nav-link">About Us</NavLink>
                                <NavLink to="/AboutUs" state={{ scrollTo: 'mission' }} className="nav-link">Our Mission & Vision</NavLink>
                                
                                <NavLink to="/AboutUs" state={{ scrollTo: 'leadership' }}  className="nav-link">Leadership Team</NavLink> */}
                                
                                <NavLink to="/PrivacyPolicy" className="nav-link">Privacy Policy</NavLink>
                                <NavLink to="/TermsAndcondition" className="nav-link">Terms & Conditions</NavLink>
                                {/* <NavLink to="/BlogsAndArticles" className="nav-link">Blogs & Articles</NavLink>
                                <NavLink to="/Gallery" className="nav-link">Gallery (Images)</NavLink>
                                <NavLink to="/LatestUpdate" className="nav-link">Latest Updates</NavLink> */}
                                
                            </div>
                        </li>

                        <li className={`nav-item dropdown ${isProductActive ? "active" : ""}`}>
                            <NavLink to="search" className="nav-link">
                                OUR SERVICES
                            </NavLink>
                            <div className="dropdown-content">
                                    <NavLink to="/WebsiteDevelopment" className="nav-link">  <FaCode className="service-iconH" />Website Development</NavLink>
                                    <NavLink to="/MobileAppDevelopment" className="nav-link"> <FaMobileAlt className="service-iconH" /> Mobile App Development</NavLink>
                                    <NavLink to="/SalesForceDevelopment" className="nav-link"> < SiSalesforce className="service-iconH" /> SalesForce Development</NavLink>
                                    <NavLink to="/DigitalMarketing" className="nav-link"><FaBullhorn className="service-iconH" /> Digital Marketing</NavLink>
                                    <NavLink to="/SoftwareSolutions" className="nav-link"><FaCloud className="service-iconH" /> Software Solutions</NavLink>
                                    <NavLink to="/MaintenanceAndSupport" className="nav-link"><FaTools className="service-iconH" /> Maintenance & Support</NavLink>
                                    <NavLink to="/Career" className="nav-link">Intenship ( Paid or Unpaid )</NavLink>
                                    
                                
                            </div>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/Contact" className="nav-link">
                                CONTACT US
                            </NavLink>
                        </li>

                            <li className="nav-item">
                                <NavLink to="/Career" className="nav-link">
                                    CAREER
                                </NavLink>
                            </li>
                    </ul>
                </nav>

                {/* --- Right Section: Search + Language --- */}
                <div className="right-section">
                    <SearchPopup onSearch={handleSearch} /> {/* ✅ Replaced SearchInput */}

                    <TranslateWidget />
                    <CustomLanguageDropdown />
                </div>
            </div>
        </header>





























            <header className="header" id="mobile-header">
            <div className="header-top">
                {/* Logo on left */}
                <div className="logo-container">
                    <NavLink to="/" className="nav-link">
                            <img
                                src={APTechLogo2}
                                alt="A.P Tech Solution"
                                className="logo"
                            />
                    </NavLink>
                </div>

              
                {/* Search in center (mobile only) */}
                <div className="mobile-search-container">
                    <SearchPopup onSearch={handleSearch} />
                </div>

                {/* Right section - language and menu */}
                <div className="header-right">
                    <div className="language-widgets">
                        <TranslateWidget />
                    
                            <MobileLanguageDropdown />
                    </div>
                    <button
                        className="mobile-menu-toggle"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle navigation menu"
                    >
                        {isMobileMenuOpen ? "✕" : "☰"}
                    </button>
                </div>
            </div>

            {/* Navigation menu */}
            <nav className={`main-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}>
                <ul>
                    <li className="nav-item">
                        <NavLink
                            to="/"
                            className="nav-link"
                            end
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            HOME
                        </NavLink>
                    </li>

                    <li
                            className={`nav-item dropdown ${isAboutActive ? "active" : ""} ${activeDropdown === 'about' ? 'active' : ''}`}
                        onClick={() => toggleDropdown('about')}
                    >
                        <div className="nav-link-with-arrow">
                            <span>ABOUT US</span>
                            <span className="dropdown-arrow">▼</span>
                        </div>
                        <div className={`dropdown-content ${activeDropdown === 'about' ? 'show' : ''}`}>
                            <NavLink to="/AboutUs" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>About</NavLink>
                            
                            <NavLink to="/PrivacyPolicy" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Privacy Policy</NavLink>
                            <NavLink to="/TermsAndcondition" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Terms & Conditions</NavLink>
                            {/* <NavLink to="/BlogsAndArticles" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Blogs & Articles</NavLink>
                            <NavLink to="/Gallery" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Gallery (Images)</NavLink>
                            <NavLink to="/LatestUpdate" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Latest Updates</NavLink> */}
                        </div>
                    </li>

                    <li
                        className={`nav-item dropdown ${isProductActive ? "active" : ""} ${activeDropdown === 'products' ? 'active' : ''}`}
                        onClick={() => toggleDropdown('products')}
                    >
                        <div className="nav-link-with-arrow">
                            <span>OUR SERVICES</span>
                            <span className="dropdown-arrow">▼</span>
                        </div>
                        <div className={`dropdown-content ${activeDropdown === 'products' ? 'show' : ''}`}>
                            <NavLink to="/WebsiteDevelopment" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>  <FaCode className="service-iconH" />Website Development</NavLink>
                             <NavLink to="/MobileAppDevelopment" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}> <FaMobileAlt className="service-iconH" /> Mobile App Development</NavLink>
                                    <NavLink to="/SalesForceDevelopment" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}> < SiSalesforce className="service-iconH" /> SalesForce Development</NavLink>
                                    <NavLink to="/DigitalMarketing" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}><FaBullhorn className="service-iconH" /> Digital Marketing</NavLink>
                                    <NavLink to="/SoftwareSolutions" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}><FaCloud className="service-iconH" /> Software Solutions</NavLink>
                                    <NavLink to="/MaintenanceAndSupport" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}><FaTools className="service-iconH" /> Maintenance & Support</NavLink>
                                    <NavLink to="/Career" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Intenship ( Paid or Unpaid )</NavLink>  
                           
                        </div>
                    </li>

                    <li className="nav-item">
                        <NavLink
                            to="/Contact"
                            className="nav-link"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            CONTACT US
                        </NavLink>
                    </li>



                        <li className="nav-item">
                            <NavLink
                                to="/Career"
                                className="nav-link"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                CAREER
                            </NavLink>
                        </li>













                </ul>
            </nav>
        </header>
        </>
    );
}

export default Header;